/* Industry is an allowlisted form value, passed only after an accepted request.
   Selection changes links only; visiting a confirmation page never emits a Lead. */
(function () {
  var industry = new URLSearchParams(window.location.search).get('industry');
  if (['home-services', 'real-estate', 'restaurants'].indexOf(industry) === -1) return;
  document.querySelectorAll('[data-ow-funnel-thanks]').forEach(function (root) {
    var options = Array.from(root.querySelectorAll('[data-ow-industry]'));
    var selected = options.find(function (option) { return option.dataset.owIndustry === industry; });
    if (!selected) return;
    var story = selected.querySelector('a');
    if (!story) return;
    options.forEach(function (option) { option.hidden = option !== selected; });
    var primary = root.querySelector('[data-ow-funnel-primary]');
    if (primary) primary.href = selected.dataset.owPrimary || story.href;
  });
}());
